<template>
    <body class="bg-pattern">
       
        <div class="bg-overlay"></div>
        <div class="account-pages my-5 pt-5">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-6 col-md-8">
                        <div class="card">
                            <div class="card-body p-4">
                                <div class="">
                                    <div class="text-center">
                                        <a href="/inicio" class="">
                                            <img src="assets/images/logo-light.png" alt="" height="24" class="auth-logo logo-dark mx-auto">
                                            <img src="assets/images/logo-light.png" alt="" height="100"  class="auth-logo logo-light mx-auto">
                                        </a>
                                    </div>
                                    <!-- end row -->
                                    <h4 class="font-size-18 text-muted mt-2 text-center"></h4>
                                    <p class="mb-5 text-center"></p>
                                    <form class="form-horizontal" action="/inicio">

                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="mb-4">
                                                    <label class="form-label" for="username">Usuario</label>
                                                    <input type="text" class="form-control" id="username" placeholder="Enter username" v-model="email">
                                                </div>
                                                <div class="mb-4">
                                                    <label class="form-label" for="userpassword">Contraseña</label>
                                                    <input type="password" class="form-control" id="userpassword" placeholder="Enter password" v-model="password">
                                                </div>

                                                <div class="row">
                                                    <!--<div class="col">
                                                        <div class="form-check">
                                                            <input type="checkbox" class="form-check-input" id="customControlInline">
                                                        </div>
                                                    </div>-->
                                                    <div class="col-7">
                                                        <!--<div class="text-md-end mt-3 mt-md-0">
                                                            <a href="auth-recoverpw.html" class="text-muted"><i class="mdi mdi-lock"></i> Forgot your password?</a>
                                                        </div>-->
                                                    </div>
                                                </div>
                                                <div class="d-grid mt-4">
                                                    <button class="btn btn-primary waves-effect waves-light" type="button" @click="login()">Ingresar</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 text-center">
                            <p class="text-white-50">v. Beta 0.0.30</p>
                           <!-- <p class="text-white-50">© Upzet. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesdesign</p>-->
                        </div>
                    </div>
                </div>
                <!-- end row -->
            </div>
        </div>
        <!-- end Account pages -->


    </body>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
export default {
    data() {
    return {
      email: '',
      password: '',
      token:'',
      role:'',
      alerta:'',
      card:false
    };
  },
  methods: {
    login() {
      var dominio = window.location.host.split(':');
      // Aquí puedes manejar la lógica para iniciar sesión
      //console.log('Iniciar sesión con:', this.email, this.password);
        axios.post(this.$rutaServer+'login',{
            email: this.email,
            password: this.password
        })
        .then(response => {
            this.token = response.data.access_token;
            this.role = response.data.role;
            //console.log(this.role + 'administrador');
            localStorage.setItem('accessToken',this.token);
            localStorage.setItem('email',this.email);
            localStorage.setItem('name',response.data.data.name);
            localStorage.setItem('id',response.data.data.id);
            this.$store.commit('setIsAuthenticated', true); // Actualizar el estado de autenticación en Vuex
            this.$store.commit('setUserRoles', this.role); // Actualizar el estado de autenticación en Vuex

            this.$router.push('/inicio');
            
            
        })
        .catch(error => {
          //console.log(error);
          this.card = true;
          this.alerta = 'Las credenciales no coinciden';
            Swal.fire('¡Error!', 'Credenciales no validas','error');
            /*if (error.response.status === 401) {
            
            console.error('Usuario no autenticado');
            } else {
            
            console.error('Error en la solicitud:', error.message);
            }*/
        });

    }
  }
}
</script>
<style>
body.bg-pattern {
   
    background-size: cover; /* Hace que la imagen cubra toda la pantalla */background-position: center; /* Centra la imagen */background-repeat: no-repeat; /* Evita que la imagen se repita */height: 100vh; /* Asegura que el body tenga la altura completa de la ventana */margin: 0; /* Elimina los márgenes por defecto */overflow: hidden; /* Evita que aparezca un scroll innecesario */
}
</style>